export default "__VITE_ASSET__DmXeybaa__"